import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledCalendar = styled.div`
  ${rtl`
.rfp-calendar-label {
    display: flex;
    position: absolute;
    top: 0;
    left: ${toRem(10)};
    background-color: ${theme.color['base-20']};
    padding: 0 ${toRem(5)};
    .icon-calendar {
      margin-right: ${toRem(5)};
    }

    [dir="rtl"] & {
      left: unset;
      right: ${toRem(10)};
    }
}
.calendar-date {
  text-transform: capitalize;
}
.DayPicker {
  display: inline-block;
  font-size: 1rem;
  position: absolute;
  background-color: ${theme.color['base-20']};
  z-index: 2;
}

.DayPicker-wrapper {
  position: relative;

  flex-direction: row;
  padding-bottom: 1em;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;
}

.DayPicker-Months {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border: ${toRem(1)} solid ${theme.color['base-10']};
}

.DayPicker-Month {
  display: table;
  margin: 0 2em;
  margin-top: 1em;
  border-spacing: 0;
  border-collapse: collapse;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;
}

.DayPicker-NavBar {
}

.DayPicker-NavButton {
  position: absolute;
  top: 1em;
  right: 1.5em;
  left: auto;

  display: inline-block;
  margin-top: ${toRem(2)};
  width: 1.25em;
  height: 1.25em;
  background-position: center;
  background-size: 50%;
  background-repeat: no-repeat;
  color: #8b9898;
  cursor: pointer;
}

.DayPicker-NavButton:hover {
  opacity: 0.8;
}

.DayPicker-NavButton--prev {
  left: ${toRem(18)};
  /* margin-right: 1.5em; */
  background-image: url('https://cdn-icons-png.flaticon.com/512/2722/2722985.png');
  transform: rotate(180deg) scale(2.5);

  [dir="rtl"] & {
    right: auto;
  }
}

.DayPicker-NavButton--next {
  right: ${toRem(18)};
  background-image: url('https://cdn-icons-png.flaticon.com/512/2722/2722985.png');
  transform: scale(2.5);

  [dir="rtl"] & {
    left: auto;
  }
}

.DayPicker-NavButton--interactionDisabled {
  display: none;
}

.DayPicker-Caption {
  display: table-caption;
  margin-bottom: 0.5em;
  padding: 0 0.5em;
  text-align: center;
}

.DayPicker-Caption > div {
  font-weight: 500;
  font-size: 1.15em;
  text-transform: uppercase;
  font-family: 'Swiss721 BT';
  opacity: 0.5;
}

.DayPicker-Weekdays {
  display: table-header-group;
  margin-top: 1em;
}

.DayPicker-WeekdaysRow {
  display: table-row;
}

.DayPicker-Weekday {
  display: table-cell;
  padding: 0.5em;
  color: #8b9898;
  text-align: center;
  font-size: 0.875em;
}

.DayPicker-Weekday abbr[title] {
  border-bottom: none;
  text-decoration: none;
  text-transform: uppercase;
  font-family: 'Swiss721 BT';
}

.DayPicker-Body {
  display: table-row-group;
}

.DayPicker-Week {
  display: table-row;
  border: ${toRem(4)} solid transparent;
}

.DayPicker-Day {
  display: table-cell;
  padding: 0.5em;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  font-family: 'Open Sans';
  color: #2c3135;
}

.DayPicker-WeekNumber {
  display: table-cell;
  padding: 0.5em;
  min-width: 1em;
  border-right: ${toRem(1)} solid #eaecec;
  color: #8b9898;
  vertical-align: middle;
  text-align: right;
  font-size: 0.75em;
  cursor: pointer;
}

.DayPicker--interactionDisabled .DayPicker-Day {
  cursor: default;
}

.DayPicker-Footer {
  padding-top: 0.5em;
}

.DayPicker-TodayButton {
  border: none;
  background-color: transparent;
  background-image: none;
  box-shadow: none;
  color: lightgrey;
  font-size: 0.875em;
  cursor: pointer;
}

/* Default modifiers */

.DayPicker-Day--today {
}

.DayPicker-Day--outside {
  color: #8b9898;
  cursor: default;
}

.DayPicker-Day .DayPicker-Day--end .DayPicker-Day--selected .DayPicker-Day--outside {
  display: none !important;
}

.DayPicker-Day--disabled {
  color: #dce0e0;
  cursor: default;
  /* background-color: #eff1f1; */
}

/* Example modifiers */

.DayPicker-Day--sunday {
  background-color: #f7f8f8;
}

.DayPicker-Day--sunday:not(.DayPicker-Day--today) {
  color: #dce0e0;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
  position: relative;
  background-color: lightgrey;
  color: ${theme.color['base-10']};
}
.DayPicker-Day--start,
.DayPicker-Day--end,
.SingleDayPicker .DayPicker-Day--selected {
  position: relative;
  background-color: ${theme.color['base-10']} !important;
  color: ${theme.color['base-20']} !important;
}

.DayPicker-Day--outside {
  background-color: ${theme.color['base-20']} !important;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
  background-color: lightgrey;
}

/* .DayPicker-Day--selected {
  background-color: ${theme.color['base-10']} !important;
  color: ${theme.color['base-20']} !important;
} */

.DayPicker:not(.DayPicker--interactionDisabled)
  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
  background-color: lightgrey;
}

/* DayPickerInput */

.DayPickerInput {
  display: inline-block;
}

.DayPickerInput-OverlayWrapper {
  position: relative;
}

.DayPickerInput-Overlay {
  position: absolute;
  left: 0;
  z-index: 1;

  background: ${theme.color['base-20']};
  box-shadow: 0 ${toRem(2)} ${toRem(5)} rgba(0, 0, 0, 0.15);
}

.DayPicker-Day {
  padding: 0.25em 1em;
}

@media ${theme.mediaQuery.allMobiles} {
  .DayPicker-Day {
    padding: ${toRem(4)} ${toRem(11)};
  }
  .DayPicker-Month {
    margin: ${toRem(16)} ${toRem(0)} ${toRem(0)};
  }
  .DayPicker-wrapper {
    width: calc(100vw - ${toRem(32)});
  }
}
.error {
  border: ${toRem(1)} solid var(--t-form-error-color) !important;
}
.error-text {
  color: var(--t-form-error-color);
}
  `}
`;
